import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import types from './types';

export default {
  state: () => state,
  getters,
  actions,
  mutations,
  types,
};
